import type { v4, Manifest } from '@sap/ux-specification-types';
import { descriptionSrcURL, syncRule, validity } from '../../../common/decoration/decorators';
import { getHeaderFacetSettingPath } from '../../application';
import type { ObjectPageCustomHeaderSectionFragment } from './ObjectPageCustomHeaderSection';

export class FlexSettings implements v4.FlexSettings {
    @syncRule({
        manifest: {
            path: (pageName: string[], manifest: Manifest, sectionId: string): string =>
                getHeaderFacetSettingPath(pageName, manifest, sectionId) + '/flexSettings'
        }
    })
    @validity({
        since: '1.81.0'
    })
    @descriptionSrcURL('https://ui5.sap.com/sdk/#/topic/ccd45ba3f0b446a0901b2c9d42b8ad53')
    designtime?: v4.DesignTime;
}

export class CommonHeaderFacetSettings implements v4.CommonHeaderFacetSettings {
    @syncRule({
        manifest: {
            path: getHeaderFacetSettingPath
        }
    })
    @validity({
        since: '1.81.0'
    })
    stashed?: boolean;

    @syncRule({
        manifest: {
            path: getHeaderFacetSettingPath
        }
    })
    @validity({
        since: '1.81.0'
    })
    flexSettings?: FlexSettings;
}

export class ObjectPageHeaderSectionForm extends CommonHeaderFacetSettings implements v4.ObjectPageHeaderSectionForm {}

export class ObjectPageHeaderSectionChart
    extends CommonHeaderFacetSettings
    implements v4.ObjectPageHeaderSectionChart {}

export class ObjectPageHeaderSectionDataPoint
    extends CommonHeaderFacetSettings
    implements v4.ObjectPageHeaderSectionDataPoint {}

export class ObjectPageHeaderSectionContact
    extends CommonHeaderFacetSettings
    implements v4.ObjectPageHeaderSectionContact {}

export class ObjectPageHeaderSectionAddress
    extends CommonHeaderFacetSettings
    implements v4.ObjectPageHeaderSectionAddress {}

export class HeaderSections implements v4.HeaderSections {
    [key: string]:
        | ObjectPageHeaderSectionForm
        | ObjectPageHeaderSectionChart
        | ObjectPageHeaderSectionDataPoint
        | ObjectPageHeaderSectionContact
        | ObjectPageHeaderSectionAddress
        | ObjectPageCustomHeaderSectionFragment;
}
